<template>
  <div class="o-container o-container--xlarge o-admin__home">
    <div class="o-grid o-grid--wrap">
      <div
        class="o-grid__cell o-grid__cell--width-100 o-grid__cell--width-25@large"
      >
        <past-fair-navigation
          class="u-display-none u-display-block@large"
          :series="$route.params.series"
        />
        <marketing-teaser :teaserType="136" />
      </div>
      <div
        class="o-grid__cell o-grid__cell--width-100 o-grid__cell--width-75@large"
      >
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import PastFairNavigation from '@/components/PastFairNavigation'
import MarketingTeaser from '@/components/MarketingTeaser'

export default {
  name: 'Fair',
  components: {
    PastFairNavigation,
    MarketingTeaser
  }
}
</script>

<style lang="scss" scoped>
.o-admin__home {
  padding: 4rem 0;

  section {
    margin-bottom: 8rem;
  }
}
</style>
